import React, { useState } from "react";
import {Box, Button, Typography, FormGroup, FormControlLabel, Checkbox, FormControl, RadioGroup, Radio} from '@mui/material';
import {IQuestionType, Question} from "../../../../common/course";
import { useTranslation } from "react-i18next";

type Props = {
    question: Question;
    answers: Question['options'];
    total: number;
    currentIdx: number;
    onSubmitAnswer: Function;
}

const MultiChoiseQuestion = ({question, onSubmitAnswer, total, currentIdx}: Props) => {
    const [answer, changeAnswersState] = useState<Record<number, number>>({});
    const {t: translate} = useTranslation();
    const indexDivider = translate('translation:ofProgress');
    const changeAnswer = (id?: number) => {
        if (typeof id !== 'number') {
            changeAnswersState({});
            return;
        }
        const savedAnswer = Object.assign({}, answer);
        if (savedAnswer[id]) {
            delete savedAnswer[id];
        } else {
            savedAnswer[id] = 1;
        }
        changeAnswersState(savedAnswer);
    };
    return (
        <Box>
            <Typography>{question.content}</Typography>
            <FormGroup sx={{mb: 2}}>
                {question.options.map(option => (
                    <FormControlLabel
                        key={option.id}
                        control={
                        <Checkbox onChange={() => changeAnswer(option.id)} checked={Boolean(answer[option.id])}
                        />}
                        label={option.value}
                    />
                ))}
            </FormGroup>
            <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', px: 4}}>
                <Button
                    variant="contained"
                    sx={{marginLeft: 'auto'}}
                    onClick={() => {
                        onSubmitAnswer({id: question.id, choices: Object.keys(answer).map(key => Number(key))});
                        changeAnswer();
                    }}
                    disabled={!(Object.keys(answer).length)}
                >
                    Далее
                </Button>
                <Typography component="span" sx={{display: 'block', marginLeft: 'auto'}}>{currentIdx + 1} из {total}</Typography>
            </Box>
        </Box>
    )
};

const SingleChoiseQuestion = ({question, onSubmitAnswer, total, currentIdx}: Props) => {
    const [answer, changeAnswer] = useState<number | undefined>();
    return (
        <Box>
            <Typography>{question.content}</Typography>
            <FormControl sx={{mb: 2}}>
                <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    onChange={(e, value) => {
                        changeAnswer(value ? Number(value) : undefined);
                    }}
                >
                    {question.options.map(option => (
                       <FormControlLabel
                            key={option.id}
                            value={option.id}
                            control={<Radio checked={option.id === answer}/>}
                            label={option.value}
                        />
                    ))}  
                </RadioGroup>
            </FormControl>
            <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', px: 4}}>
                <Button
                    variant="contained"
                    sx={{marginLeft: 'auto'}}
                    onClick={() => {
                        onSubmitAnswer({id: question.id, choices: [answer]});
                        changeAnswer(undefined);
                    }}
                    disabled={typeof answer !== 'number'}
                >
                    Далее
                </Button>
                <Typography component="span" sx={{display: 'block', marginLeft: 'auto'}}>{currentIdx + 1} из {total}</Typography>
            </Box>
        </Box>
    )
}

const questionParsers: Record<IQuestionType, Function> = {
    [IQuestionType.MULTI_CHOISE]: MultiChoiseQuestion,
    [IQuestionType.SINGLE_CHOISE]: SingleChoiseQuestion,
};
const View = ({question, total, currentIdx, onSubmitAnswer}: Props) => {
    if (!question?.type) {
        return null;
    }
    const Parser = questionParsers[question.type];
    if (!Parser) {
        return null;
    }
    //@ts-ignore
    return <Parser question={question} total={total} currentIdx={currentIdx} onSubmitAnswer={onSubmitAnswer}/>;
};

export default View;